import { Expose } from "class-transformer";
import { IsString } from "class-validator";

export class AdministrationOffice {
  @Expose()
  @IsString()
  id!: string;
  @Expose()
  @IsString()
  name!: string;
  @Expose()
  @IsString()
  shortName!: string;
}
